import { render, staticRenderFns } from "./CounselViewPage.vue?vue&type=template&id=ffea8d92&"
import script from "./CounselViewPage.vue?vue&type=script&lang=js&"
export * from "./CounselViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports